// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1YU7e","buttons":"RemoveExpirationActionButtons_buttons__UBH78"};